/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Stat_DistanceInputs */

const en_ui_studio_stat_distance = /** @type {(inputs: Ui_Studio_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distance`)
};

const de_ui_studio_stat_distance = /** @type {(inputs: Ui_Studio_Stat_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Distanz`)
};

/**
* | output |
* | --- |
* | "Distance" |
*
* @param {Ui_Studio_Stat_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_stat_distance = /** @type {((inputs?: Ui_Studio_Stat_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Stat_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_stat_distance(inputs)
	return de_ui_studio_stat_distance(inputs)
});